/*
 * Code generated by build-scripts/codegen/expectation-catalog.ts, DO NOT EDIT.
 */

import { JSONSchema } from "json-schema-to-ts"
export const jsonSchemas = {
  expectColumnDistinctValuesToBeInSet: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Uniqueness"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Aggregate", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnDistinctValuesToBeInSet",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_distinct_values_to_be_in_set",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column aggregate expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the set of distinct column values to be contained by a given set.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        value_set: {
          description: "A set of objects used for comparison.",
          oneOf: [
            {
              title: "Text",
              type: "array",
              items: { type: "string", minLength: 1 },
              minItems: 1,
              examples: [
                ["a", "b", "c", "d", "e"],
                ["2024-01-01", "2024-01-02", "2024-01-03", "2024-01-04", "2024-01-05"],
              ],
            },
            {
              title: "Numbers",
              type: "array",
              items: { type: "number" },
              minItems: 1,
              examples: [
                [1, 2, 3, 4, 5],
                [1.1, 2.2, 3.3, 4.4, 5.5],
                [1, 2.2, 3, 4.4, 5],
              ],
            },
          ],
          title: "Value Set",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "value_set"],
      title: "Expect column distinct values to be in set",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnDistinctValuesToContainSet: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Uniqueness"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Aggregate", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnDistinctValuesToContainSet",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_distinct_values_to_contain_set",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column aggregate expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the set of distinct column values to contain a given set.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        value_set: {
          description: "A set of objects used for comparison.",
          oneOf: [
            {
              title: "Text",
              type: "array",
              items: { type: "string", minLength: 1 },
              minItems: 1,
              examples: [
                ["a", "b", "c", "d", "e"],
                ["2024-01-01", "2024-01-02", "2024-01-03", "2024-01-04", "2024-01-05"],
              ],
            },
            {
              title: "Numbers",
              type: "array",
              items: { type: "number" },
              minItems: 1,
              examples: [
                [1, 2, 3, 4, 5],
                [1.1, 2.2, 3.3, 4.4, 5.5],
                [1, 2.2, 3, 4.4, 5],
              ],
            },
          ],
          title: "Value Set",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "value_set"],
      title: "Expect column distinct values to contain set",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnDistinctValuesToEqualSet: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Uniqueness"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Aggregate", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnDistinctValuesToEqualSet",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_distinct_values_to_equal_set",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column aggregate expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the set of distinct column values to equal a given set.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        value_set: {
          description: "A set of objects used for comparison.",
          oneOf: [
            {
              title: "Text",
              type: "array",
              items: { type: "string", minLength: 1 },
              minItems: 1,
              examples: [
                ["a", "b", "c", "d", "e"],
                ["2024-01-01", "2024-01-02", "2024-01-03", "2024-01-04", "2024-01-05"],
              ],
            },
            {
              title: "Numbers",
              type: "array",
              items: { type: "number" },
              minItems: 1,
              examples: [
                [1, 2, 3, 4, 5],
                [1.1, 2.2, 3.3, 4.4, 5.5],
                [1, 2.2, 3, 4.4, 5],
              ],
            },
          ],
          title: "Value Set",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "value_set"],
      title: "Expect column distinct values to equal set",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnKlDivergenceToBeLessThan: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        bucketize_data: {
          default: true,
          description:
            "If True, then continuous data will be bucketized before evaluation. Setting this parameter to false allows evaluation of KL divergence with a None partition object for profiling against discrete data.",
          title: "Bucketize Data",
          type: "boolean",
        },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        internal_weight_holdout: {
          default: 0,
          description:
            "The amount of weight to split uniformly among zero-weighted partition bins. internal_weight_holdout provides a mechanisms to make the test less strict by assigning positive weights to values observed in the data for which the partition explicitly expected zero weight.",
          maximum: 1,
          minimum: 0,
          title: "Internal Weight Holdout",
          type: "number",
        },
        max_value: {
          anyOf: [{ type: "number" }, { type: "string", format: "date" }, { type: "string", format: "date-time" }],
          description: "The maximum value for the column.",
          title: "Max Value",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Numeric"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Aggregate", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnKLDivergenceToBeLessThan",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_kl_divergence_to_be_less_than",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column aggregate expectation", "distributional expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const:
                "Expect the Kulback-Leibler (KL) divergence (relative entropy) of the specified column with respect to the partition object to be lower than the provided threshold.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: ["Pandas", "Spark", "SQLite", "PostgreSQL", "MySQL", "MSSQL", "BigQuery", "Snowflake", "Redshift"],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        min_value: {
          anyOf: [{ type: "number" }, { type: "string", format: "date" }, { type: "string", format: "date-time" }],
          description: "The minimum value for the column.",
          title: "Min Value",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        partition_object: { description: "The expected partition object.", title: "Partition Object", type: "object" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        tail_weight_holdout: {
          default: 0,
          description:
            "The amount of weight to add to the tails of the histogram.Tail weight holdout is split evenly between (-Infinity, min(partition_object['bins'])) and (max(partition_object['bins']), +Infinity). tail_weight_holdout provides a mechanism to make the test less strict by assigning positive weights to values observed in the data that are not present in the partition. With no tail_weight_holdout, any value observed outside the provided partition_object will cause KL divergence to rise to +Infinity. Defaults to 0.",
          maximum: 1,
          minimum: 0,
          title: "Tail Weight Holdout",
          type: "number",
        },
        threshold: {
          description:
            "The maximum KL divergence to for which to return success=True. If KL divergence is largerthan the provided threshold, the test will return success=False.",
          title: "Threshold",
          type: "number",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column"],
      title: "Expect column KL divergence to be less than",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnMaxToBeBetween: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        max_value: {
          anyOf: [{ type: "number" }, { type: "string", format: "date" }, { type: "string", format: "date-time" }],
          description: "The maximum value of the acceptable range for the column maximum.",
          title: "Max Value",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Numeric"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Aggregate", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectColumnMaxToBeBetween", title: "Expectation Class", type: "string" },
            expectation_type: { const: "expect_column_max_to_be_between", title: "Expectation Type", type: "string" },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column aggregate expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the column maximum to be between a minimum value and a maximum value.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        min_value: {
          anyOf: [{ type: "number" }, { type: "string", format: "date" }, { type: "string", format: "date-time" }],
          description: "The minimum value of the acceptable range for the column maximum.",
          title: "Min Value",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        strict_max: {
          default: false,
          description:
            "If True, the upper bound of the column maximum acceptable rangemust be strictly smaller than max_value, default=False",
          title: "Strict Max",
          type: "boolean",
        },
        strict_min: {
          default: false,
          description:
            "If True, the lower bound of the column maximum acceptable rangemust be strictly larger than min_value, default=False",
          title: "Strict Min",
          type: "boolean",
        },
        to_be_between: {
          default: { max_value: null, min_value: null, strict_max: false, strict_min: false },
          oneOf: [
            {
              title: "a dynamic range of",
              type: "object",
              properties: {
                offset: { type: "string", enum: ["+/-", "+", "-"], default: "+/-" },
                percent: { type: "number" },
                range: { type: "number" },
                strict: { type: "boolean", default: false },
                isDynamicRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["offset", "percent", "range", "isDynamicRange"],
            },
            {
              title: "the fixed values",
              type: "object",
              properties: {
                max_value: {
                  title: "Max Value",
                  description: "The maximum value of the acceptable range for the column maximum.",
                  anyOf: [
                    { type: "number" },
                    { type: "string", format: "date" },
                    { type: "string", format: "date-time" },
                    { type: "null" },
                  ],
                },
                strict_max: { type: "boolean", default: false },
                min_value: {
                  title: "Min Value",
                  description: "The minimum value of the acceptable range for the column maximum.",
                  anyOf: [
                    { type: "number" },
                    { type: "string", format: "date" },
                    { type: "string", format: "date-time" },
                    { type: "null" },
                  ],
                },
                strict_min: { type: "boolean", default: false },
                isFixedRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["isFixedRange"],
            },
          ],
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column"],
      title: "Expect column maximum to be between",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnMeanToBeBetween: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        max_value: {
          anyOf: [{ type: "number" }, { type: "string", format: "date" }, { type: "string", format: "date-time" }],
          description: "The maximum value for the column mean.",
          title: "Max Value",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Numeric"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Aggregate", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectColumnMeanToBeBetween", title: "Expectation Class", type: "string" },
            expectation_type: { const: "expect_column_mean_to_be_between", title: "Expectation Type", type: "string" },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column aggregate expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the column mean to be between a minimum value and a maximum value (inclusive).",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        min_value: {
          anyOf: [{ type: "number" }, { type: "string", format: "date" }, { type: "string", format: "date-time" }],
          description: "The minimum value for the column mean.",
          title: "Min Value",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        strict_max: {
          default: false,
          description: "If True, the column mean must be strictly smaller than max_value, default=False",
          title: "Strict Max",
          type: "boolean",
        },
        strict_min: {
          default: false,
          description: "If True, the column mean must be strictly larger than min_value, default=False",
          title: "Strict Min",
          type: "boolean",
        },
        to_be_between: {
          default: { max_value: null, min_value: null, strict_max: false, strict_min: false },
          oneOf: [
            {
              title: "a dynamic range of",
              type: "object",
              properties: {
                offset: { type: "string", enum: ["+/-", "+", "-"], default: "+/-" },
                percent: { type: "number" },
                range: { type: "number" },
                strict: { type: "boolean", default: false },
                isDynamicRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["offset", "percent", "range", "isDynamicRange"],
            },
            {
              title: "the fixed values",
              type: "object",
              properties: {
                max_value: {
                  title: "Max Value",
                  description: "The maximum value for the column mean.",
                  anyOf: [
                    { type: "number" },
                    { type: "string", format: "date" },
                    { type: "string", format: "date-time" },
                    { type: "null" },
                  ],
                },
                strict_max: { type: "boolean", default: false },
                min_value: {
                  title: "Min Value",
                  description: "The minimum value for the column mean.",
                  anyOf: [
                    { type: "number" },
                    { type: "string", format: "date" },
                    { type: "string", format: "date-time" },
                    { type: "null" },
                  ],
                },
                strict_min: { type: "boolean", default: false },
                isFixedRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["isFixedRange"],
            },
          ],
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column"],
      title: "Expect column mean to be between",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnMedianToBeBetween: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        max_value: {
          anyOf: [{ type: "number" }, { type: "string", format: "date" }, { type: "string", format: "date-time" }],
          description: "The maximum value for the column median.",
          title: "Max Value",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Numeric"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Aggregate", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectColumnMedianToBeBetween", title: "Expectation Class", type: "string" },
            expectation_type: {
              const: "expect_column_median_to_be_between",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column aggregate expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the column median to be between a minimum value and a maximum value.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        min_value: {
          anyOf: [{ type: "number" }, { type: "string", format: "date" }, { type: "string", format: "date-time" }],
          description: "The minimum value for the column median.",
          title: "Min Value",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        strict_max: {
          default: false,
          description: "If True, the column median must be strictly smaller than max_value, default=False",
          title: "Strict Max",
          type: "boolean",
        },
        strict_min: {
          default: false,
          description: "If True, the column median must be strictly larger than min_value, default=False",
          title: "Strict Min",
          type: "boolean",
        },
        to_be_between: {
          default: { max_value: null, min_value: null, strict_max: false, strict_min: false },
          oneOf: [
            {
              title: "a dynamic range of",
              type: "object",
              properties: {
                offset: { type: "string", enum: ["+/-", "+", "-"], default: "+/-" },
                percent: { type: "number" },
                range: { type: "number" },
                strict: { type: "boolean", default: false },
                isDynamicRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["offset", "percent", "range", "isDynamicRange"],
            },
            {
              title: "the fixed values",
              type: "object",
              properties: {
                max_value: {
                  title: "Max Value",
                  description: "The maximum value for the column median.",
                  anyOf: [
                    { type: "number" },
                    { type: "string", format: "date" },
                    { type: "string", format: "date-time" },
                    { type: "null" },
                  ],
                },
                strict_max: { type: "boolean", default: false },
                min_value: {
                  title: "Min Value",
                  description: "The minimum value for the column median.",
                  anyOf: [
                    { type: "number" },
                    { type: "string", format: "date" },
                    { type: "string", format: "date-time" },
                    { type: "null" },
                  ],
                },
                strict_min: { type: "boolean", default: false },
                isFixedRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["isFixedRange"],
            },
          ],
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column"],
      title: "Expect column median to be between",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnMinToBeBetween: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        max_value: {
          anyOf: [{ type: "number" }, { type: "string", format: "date" }, { type: "string", format: "date-time" }],
          description: "The maximal column minimum allowed.",
          title: "Max Value",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Numeric"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Aggregate", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectColumnMinToBeBetween", title: "Expectation Class", type: "string" },
            expectation_type: { const: "expect_column_min_to_be_between", title: "Expectation Type", type: "string" },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column aggregate expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the column minimum to be between a minimum value and a maximum value.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        min_value: {
          anyOf: [{ type: "number" }, { type: "string", format: "date" }, { type: "string", format: "date-time" }],
          description: "The minimal column minimum allowed.",
          title: "Min Value",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        strict_max: {
          default: false,
          description: "If True, the maximal column minimum must be strictly smaller than max_value, default=False",
          title: "Strict Max",
          type: "boolean",
        },
        strict_min: {
          default: false,
          description: "If True, the minimal column minimum must be strictly larger than min_value, default=False",
          title: "Strict Min",
          type: "boolean",
        },
        to_be_between: {
          default: { max_value: null, min_value: null, strict_max: false, strict_min: false },
          oneOf: [
            {
              title: "a dynamic range of",
              type: "object",
              properties: {
                offset: { type: "string", enum: ["+/-", "+", "-"], default: "+/-" },
                percent: { type: "number" },
                range: { type: "number" },
                strict: { type: "boolean", default: false },
                isDynamicRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["offset", "percent", "range", "isDynamicRange"],
            },
            {
              title: "the fixed values",
              type: "object",
              properties: {
                max_value: {
                  title: "Max Value",
                  description: "The maximal column minimum allowed.",
                  anyOf: [
                    { type: "number" },
                    { type: "string", format: "date" },
                    { type: "string", format: "date-time" },
                    { type: "null" },
                  ],
                },
                strict_max: { type: "boolean", default: false },
                min_value: {
                  title: "Min Value",
                  description: "The minimal column minimum allowed.",
                  anyOf: [
                    { type: "number" },
                    { type: "string", format: "date" },
                    { type: "string", format: "date-time" },
                    { type: "null" },
                  ],
                },
                strict_min: { type: "boolean", default: false },
                isFixedRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["isFixedRange"],
            },
          ],
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column"],
      title: "Expect column minimum to be between",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnMostCommonValueToBeInSet: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Validity"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Aggregate", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnMostCommonValueToBeInSet",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_most_common_value_to_be_in_set",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column aggregate expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the most common value to be within the designated value set.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        ties_okay: {
          description:
            "If True, then the expectation will still succeed if values outside the designated set are as common (but not more common) than designated values.",
          title: "Ties Okay",
          type: "boolean",
        },
        value_set: {
          description: "A set of objects used for comparison.",
          oneOf: [
            {
              title: "Text",
              type: "array",
              items: { type: "string", minLength: 1 },
              minItems: 1,
              examples: [
                ["a", "b", "c", "d", "e"],
                ["2024-01-01", "2024-01-02", "2024-01-03", "2024-01-04", "2024-01-05"],
              ],
            },
            {
              title: "Numbers",
              type: "array",
              items: { type: "number" },
              minItems: 1,
              examples: [
                [1, 2, 3, 4, 5],
                [1.1, 2.2, 3.3, 4.4, 5.5],
                [1, 2.2, 3, 4.4, 5],
              ],
            },
          ],
          title: "Value Set",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "value_set"],
      title: "Expect column most common value to be in set",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnPairValuesAToBeGreaterThanB: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column_A: { description: "The first column name.", minLength: 1, title: "Column A", type: "string" },
        column_B: { description: "The second column name.", minLength: 1, title: "Column B", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        ignore_row_if: {
          default: "both_values_are_missing",
          description: "If specified, sets the condition on which a given row is to be ignored.",
          enum: ["both_values_are_missing", "either_value_is_missing", "neither"],
          title: "Ignore Row If",
          type: "string",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Numeric"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column_pair", description: "Column Pair Map", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnPairValuesAToBeGreaterThanB",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_pair_values_a_to_be_greater_than_b",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column pair map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the values in column A to be greater than column B.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        or_equal: {
          description: "If True, then values can be equal, not strictly greater.",
          title: "Or Equal",
          type: "boolean",
        },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column_A", "column_B", "mostly"],
      title: "Expect column pair values A to be greater than B",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnPairValuesToBeEqual: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column_A: { description: "The first column name.", minLength: 1, title: "Column A", type: "string" },
        column_B: { description: "The second column name.", minLength: 1, title: "Column B", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        ignore_row_if: {
          default: "both_values_are_missing",
          description: "If specified, sets the condition on which a given row is to be ignored.",
          enum: ["both_values_are_missing", "either_value_is_missing", "neither"],
          title: "Ignore Row If",
          type: "string",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Validity"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column_pair", description: "Column Pair Map", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectColumnPairValuesToBeEqual", title: "Expectation Class", type: "string" },
            expectation_type: {
              const: "expect_column_pair_values_to_be_equal",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column pair map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the values in column A to be the same as column B.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column_A", "column_B", "mostly"],
      title: "Expect column pair values to be equal",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnPairValuesToBeInSet: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column_A: { description: "The first column name.", minLength: 1, title: "Column A", type: "string" },
        column_B: { description: "The second column name.", minLength: 1, title: "Column B", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        ignore_row_if: {
          default: "both_values_are_missing",
          enum: ["both_values_are_missing", "either_value_is_missing", "neither"],
          title: "Ignore Row If",
          type: "string",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Validity"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column_pair", description: "Column Pair Map", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectColumnPairValuesToBeInSet", title: "Expectation Class", type: "string" },
            expectation_type: {
              const: "expect_column_pair_values_to_be_in_set",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column pair map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the paired values from columns A and B to belong to a set of valid pairs.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: ["Pandas", "Spark", "SQLite", "PostgreSQL", "MySQL", "MSSQL", "BigQuery", "Snowflake", "Redshift"],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        value_pairs_set: {
          items: { items: [{}, {}], maxItems: 2, minItems: 2, type: "array" },
          title: "Value Pairs Set",
          type: "array",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column_A", "column_B", "value_pairs_set", "mostly"],
      title: "Expect column pair values to be in set",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnProportionOfNonNullValuesToBeBetween: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        library_metadata: {
          default: {
            contributors: ["@great_expectations"],
            has_full_test_suite: true,
            manually_reviewed_code: true,
            maturity: "production",
            requirements: [],
            tags: ["core expectation", "column aggregate expectation"],
          },
          title: "Library Metadata",
          type: "object",
        },
        max_value: {
          description: "The maximum proportion of non-null values (proportions are on the range 0 to 1).",
          title: "Max Value",
          type: "number",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Completeness"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Aggregate", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnProportionOfNonNullValuesToBeBetween",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_proportion_of_non_null_values_to_be_between",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column aggregate expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the proportion of non-null values to be between a minimum value and a maximum value.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        min_value: {
          description: "The minimum proportion of non-null values (proportions are on the range 0 to 1).",
          title: "Min Value",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        strict_max: {
          default: false,
          description: "If True, the maximum proportion of non-null values must be strictly smaller than max_value.",
          title: "Strict Max",
          type: "boolean",
        },
        strict_min: {
          default: false,
          description: "If True, the minimum proportion of non-null values must be strictly larger than min_value.",
          title: "Strict Min",
          type: "boolean",
        },
        to_be_between: {
          default: { max_value: null, min_value: null, strict_max: false, strict_min: false },
          oneOf: [
            {
              title: "a dynamic range of",
              type: "object",
              properties: {
                offset: { type: "string", enum: ["+/-", "+", "-"], default: "+/-" },
                percent: { type: "number" },
                range: { type: "number" },
                strict: { type: "boolean", default: false },
                isDynamicRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["offset", "percent", "range", "isDynamicRange"],
            },
            {
              title: "the fixed values",
              type: "object",
              properties: {
                max_value: {
                  title: "Max Value",
                  description: "The maximum proportion of non-null values (proportions are on the range 0 to 1).",
                  anyOf: [{ type: "number" }, { type: "null" }],
                },
                strict_max: { type: "boolean", default: false },
                min_value: {
                  title: "Min Value",
                  description: "The minimum proportion of non-null values (proportions are on the range 0 to 1).",
                  anyOf: [{ type: "number" }, { type: "null" }],
                },
                strict_min: { type: "boolean", default: false },
                isFixedRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["isFixedRange"],
            },
          ],
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column"],
      title: "Expect column proportion of non-null values to be between",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnProportionOfUniqueValuesToBeBetween: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        library_metadata: {
          default: {
            contributors: ["@great_expectations"],
            has_full_test_suite: true,
            manually_reviewed_code: true,
            maturity: "production",
            requirements: [],
            tags: ["core expectation", "column aggregate expectation"],
          },
          title: "Library Metadata",
          type: "object",
        },
        max_value: {
          description: "The maximum proportion of unique values (Proportions are on the range 0 to 1).",
          title: "Max Value",
          type: "number",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Uniqueness"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Aggregate", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnProportionOfUniqueValuesToBeBetween",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_proportion_of_unique_values_to_be_between",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column aggregate expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the proportion of unique values to be between a minimum value and a maximum value.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        min_value: {
          description: "The minimum proportion of unique values (Proportions are on the range 0 to 1).",
          title: "Min Value",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        strict_max: {
          default: false,
          description: "If True, the maximum proportion of unique values must be strictly smaller than max_value.",
          title: "Strict Max",
          type: "boolean",
        },
        strict_min: {
          default: false,
          description: "If True, the minimum proportion of unique values must be strictly larger than min_value.",
          title: "Strict Min",
          type: "boolean",
        },
        to_be_between: {
          default: { max_value: null, min_value: null, strict_max: false, strict_min: false },
          oneOf: [
            {
              title: "a dynamic range of",
              type: "object",
              properties: {
                offset: { type: "string", enum: ["+/-", "+", "-"], default: "+/-" },
                percent: { type: "number" },
                range: { type: "number" },
                strict: { type: "boolean", default: false },
                isDynamicRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["offset", "percent", "range", "isDynamicRange"],
            },
            {
              title: "the fixed values",
              type: "object",
              properties: {
                max_value: {
                  title: "Max Value",
                  description: "The maximum proportion of unique values (Proportions are on the range 0 to 1).",
                  anyOf: [{ type: "number" }, { type: "null" }],
                },
                strict_max: { type: "boolean", default: false },
                min_value: {
                  title: "Min Value",
                  description: "The minimum proportion of unique values (Proportions are on the range 0 to 1).",
                  anyOf: [{ type: "number" }, { type: "null" }],
                },
                strict_min: { type: "boolean", default: false },
                isFixedRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["isFixedRange"],
            },
          ],
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column"],
      title: "Expect column proportion of unique values to be between",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnQuantileValuesToBeBetween: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        QuantileRange: {
          properties: {
            quantiles: { items: { type: "number" }, title: "Quantiles", type: "array" },
            value_ranges: {
              items: { items: { anyOf: [{ type: "number" }, { type: "integer" }] }, type: "array" },
              title: "Value Ranges",
              type: "array",
            },
          },
          required: ["quantiles", "value_ranges"],
          title: "QuantileRange",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        allow_relative_error: {
          anyOf: [{ type: "boolean" }, { type: "string" }],
          default: false,
          description:
            "Whether to allow relative error in quantile communications on backends that support or require it.",
          title: "Allow Relative Error",
        },
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Numeric"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Aggregate", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnQuantileValuesToBeBetween",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_quantile_values_to_be_between",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column aggregate expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the specific provided column quantiles to be between a minimum value and a maximum value.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: ["Pandas", "Spark", "SQLite", "PostgreSQL", "MySQL", "MSSQL", "BigQuery", "Snowflake", "Redshift"],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        quantile_ranges: {
          $ref: "#/definitions/QuantileRange",
          description:
            "Key 'quantiles' is an increasingly ordered list of desired quantile values (floats). Key 'value_ranges' is a list of 2-value lists that specify a lower and upper bound (inclusive) for the corresponding quantile (with [min, max] ordering).",
          title: "Quantile Ranges",
        },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "quantile_ranges"],
      title: "Expect column quantile values to be between",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnStdevToBeBetween: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        max_value: {
          anyOf: [{ type: "number" }, { type: "string", format: "date" }, { type: "string", format: "date-time" }],
          description: "The maximum value for the column standard deviation.",
          title: "Max Value",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Numeric"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Aggregate", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectColumnStdevToBeBetween", title: "Expectation Class", type: "string" },
            expectation_type: { const: "expect_column_stdev_to_be_between", title: "Expectation Type", type: "string" },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column aggregate expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the column standard deviation to be between a minimum value and a maximum value.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        min_value: {
          anyOf: [{ type: "number" }, { type: "string", format: "date" }, { type: "string", format: "date-time" }],
          description: "The minimum value for the column standard deviation.",
          title: "Min Value",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        strict_max: {
          default: false,
          description: "If True, the column standard deviation must be strictly smaller than max_value.",
          title: "Strict Max",
          type: "boolean",
        },
        strict_min: {
          default: false,
          description: "If True, the column standard deviation must be strictly larger than min_value.",
          title: "Strict Min",
          type: "boolean",
        },
        to_be_between: {
          default: { max_value: null, min_value: null, strict_max: false, strict_min: false },
          oneOf: [
            {
              title: "a dynamic range of",
              type: "object",
              properties: {
                offset: { type: "string", enum: ["+/-", "+", "-"], default: "+/-" },
                percent: { type: "number" },
                range: { type: "number" },
                strict: { type: "boolean", default: false },
                isDynamicRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["offset", "percent", "range", "isDynamicRange"],
            },
            {
              title: "the fixed values",
              type: "object",
              properties: {
                max_value: {
                  title: "Max Value",
                  description: "The maximum value for the column standard deviation.",
                  anyOf: [
                    { type: "number" },
                    { type: "string", format: "date" },
                    { type: "string", format: "date-time" },
                    { type: "null" },
                  ],
                },
                strict_max: { type: "boolean", default: false },
                min_value: {
                  title: "Min Value",
                  description: "The minimum value for the column standard deviation.",
                  anyOf: [
                    { type: "number" },
                    { type: "string", format: "date" },
                    { type: "string", format: "date-time" },
                    { type: "null" },
                  ],
                },
                strict_min: { type: "boolean", default: false },
                isFixedRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["isFixedRange"],
            },
          ],
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column"],
      title: "Expect column standard deviation to be between",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnSumToBeBetween: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        max_value: {
          anyOf: [{ type: "number" }, { type: "string", format: "date" }, { type: "string", format: "date-time" }],
          description: "The maximal sum allowed.",
          title: "Max Value",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Numeric"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Aggregate", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectColumnSumToBeBetween", title: "Expectation Class", type: "string" },
            expectation_type: { const: "expect_column_sum_to_be_between", title: "Expectation Type", type: "string" },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column aggregate expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the column sum to be between a minimum value and a maximum value.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        min_value: {
          anyOf: [{ type: "number" }, { type: "string", format: "date" }, { type: "string", format: "date-time" }],
          description: "The minimal sum allowed.",
          title: "Min Value",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        strict_max: {
          default: false,
          description: "If True, the maximal sum must be strictly smaller than max_value.",
          title: "Strict Max",
          type: "boolean",
        },
        strict_min: {
          default: false,
          description: "If True, the minimal sum must be strictly larger than min_value.",
          title: "Strict Min",
          type: "boolean",
        },
        to_be_between: {
          default: { max_value: null, min_value: null, strict_max: false, strict_min: false },
          oneOf: [
            {
              title: "a dynamic range of",
              type: "object",
              properties: {
                offset: { type: "string", enum: ["+/-", "+", "-"], default: "+/-" },
                percent: { type: "number" },
                range: { type: "number" },
                strict: { type: "boolean", default: false },
                isDynamicRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["offset", "percent", "range", "isDynamicRange"],
            },
            {
              title: "the fixed values",
              type: "object",
              properties: {
                max_value: {
                  title: "Max Value",
                  description: "The maximal sum allowed.",
                  anyOf: [
                    { type: "number" },
                    { type: "string", format: "date" },
                    { type: "string", format: "date-time" },
                    { type: "null" },
                  ],
                },
                strict_max: { type: "boolean", default: false },
                min_value: {
                  title: "Min Value",
                  description: "The minimal sum allowed.",
                  anyOf: [
                    { type: "number" },
                    { type: "string", format: "date" },
                    { type: "string", format: "date-time" },
                    { type: "null" },
                  ],
                },
                strict_min: { type: "boolean", default: false },
                isFixedRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["isFixedRange"],
            },
          ],
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column"],
      title: "Expect column sum to be between",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnToExist: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        column_index: {
          description:
            "If not None, checks the order of the columns. The expectation will fail if the column is not in location column_index (zero-indexed).",
          title: "Column Index",
          type: "integer",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Schema"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "table", description: "Batch", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectColumnToExist", title: "Expectation Class", type: "string" },
            expectation_type: { const: "expect_column_to_exist", title: "Expectation Type", type: "string" },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "table expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Checks for the existence of a specified column within a table.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column"],
      title: "Expect column to exist",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnUniqueValueCountToBeBetween: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        library_metadata: {
          default: {
            contributors: ["@great_expectations"],
            has_full_test_suite: true,
            manually_reviewed_code: true,
            maturity: "production",
            requirements: [],
            tags: ["core expectation", "column aggregate expectation"],
          },
          title: "Library Metadata",
          type: "object",
        },
        max_value: {
          anyOf: [{ type: "number" }, { type: "string", format: "date" }, { type: "string", format: "date-time" }],
          description: "The maximum number of unique values allowed.",
          title: "Max Value",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Uniqueness"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Aggregate", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnUniqueValueCountToBeBetween",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_unique_value_count_to_be_between",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column aggregate expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the number of unique values to be between a minimum value and a maximum value.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        min_value: {
          anyOf: [{ type: "number" }, { type: "string", format: "date" }, { type: "string", format: "date-time" }],
          description: "The minimum number of unique values allowed.",
          title: "Min Value",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        strict_max: {
          default: false,
          description: "If True, the column must have strictly fewer unique value count than max_value to pass.",
          title: "Strict Max",
          type: "boolean",
        },
        strict_min: {
          default: false,
          description: "If True, the column must have strictly more unique value count than min_value to pass.",
          title: "Strict Min",
          type: "boolean",
        },
        to_be_between: {
          default: { max_value: null, min_value: null, strict_max: false, strict_min: false },
          oneOf: [
            {
              title: "a dynamic range of",
              type: "object",
              properties: {
                offset: { type: "string", enum: ["+/-", "+", "-"], default: "+/-" },
                percent: { type: "number" },
                range: { type: "number" },
                strict: { type: "boolean", default: false },
                isDynamicRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["offset", "percent", "range", "isDynamicRange"],
            },
            {
              title: "the fixed values",
              type: "object",
              properties: {
                max_value: {
                  title: "Max Value",
                  description: "The maximum number of unique values allowed.",
                  anyOf: [
                    { type: "number" },
                    { type: "string", format: "date" },
                    { type: "string", format: "date-time" },
                    { type: "null" },
                  ],
                },
                strict_max: { type: "boolean", default: false },
                min_value: {
                  title: "Min Value",
                  description: "The minimum number of unique values allowed.",
                  anyOf: [
                    { type: "number" },
                    { type: "string", format: "date" },
                    { type: "string", format: "date-time" },
                    { type: "null" },
                  ],
                },
                strict_min: { type: "boolean", default: false },
                isFixedRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["isFixedRange"],
            },
          ],
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column"],
      title: "Expect column unique value count to be between",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValueLengthsToBeBetween: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        max_value: {
          anyOf: [{ type: "integer" }, { type: "string", format: "date-time" }],
          description: "The maximum value for a column entry length.",
          title: "Max Value",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Validity"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnValueLengthsToBeBetween",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_value_lengths_to_be_between",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const:
                "Expect the column entries to be strings with length between a minimum value and a maximum value (inclusive).",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        min_value: {
          anyOf: [{ type: "integer" }, { type: "string", format: "date-time" }],
          description: "The minimum value for a column entry length.",
          title: "Min Value",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        strict_max: {
          default: false,
          description: "If True, values must be strictly smaller than max_value.",
          title: "Strict Max",
          type: "boolean",
        },
        strict_min: {
          default: false,
          description: "If True, values must be strictly larger than min_value.",
          title: "Strict Min",
          type: "boolean",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "mostly"],
      title: "Expect column value lengths to be between",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValueLengthsToEqual: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Validity"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectColumnValueLengthsToEqual", title: "Expectation Class", type: "string" },
            expectation_type: {
              const: "expect_column_value_lengths_to_equal",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the column entries to be strings with length equal to the provided value.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        value: { description: "The expected value for a column entry length.", title: "Value", type: "number" },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "value", "mostly"],
      title: "Expect column value lengths to equal",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValueZScoresToBeLessThan: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        double_sided: {
          default: false,
          description:
            "A True or False value indicating whether to evaluate double sidedly. Examples: (double_sided = True, threshold = 2) -> Z scores in non-inclusive interval(-2,2) | (double_sided = False, threshold = 2) -> Z scores in non-inclusive interval (-infinity,2)",
          title: "Double Sided",
          type: "boolean",
        },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Numeric"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnValueZScoresToBeLessThan",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_value_z_scores_to_be_less_than",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the Z-scores of a column's values to be less than a given threshold.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        threshold: {
          description:
            "A maximum Z-score threshold. All column Z-scores that are lower than this threshold will evaluate successfully.",
          title: "Threshold",
          type: "number",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "threshold", "double_sided", "mostly"],
      title: "Expect column value z-scores to be less than",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToBeBetween: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        max_value: {
          anyOf: [{ type: "number" }, { type: "string", format: "date" }, { type: "string", format: "date-time" }],
          description: "The maximum value for a column entry.",
          title: "Max Value",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Numeric"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectColumnValuesToBeBetween", title: "Expectation Class", type: "string" },
            expectation_type: {
              const: "expect_column_values_to_be_between",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the column entries to be between a minimum value and a maximum value (inclusive).",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        min_value: {
          anyOf: [{ type: "number" }, { type: "string", format: "date" }, { type: "string", format: "date-time" }],
          description: "The minimum value for a column entry.",
          title: "Min Value",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        strict_max: {
          default: false,
          description: "The maximum value for a column entry.",
          title: "Strict Max",
          type: "boolean",
        },
        strict_min: {
          default: false,
          description: "If True, values must be strictly larger than min_value.",
          title: "Strict Min",
          type: "boolean",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "mostly"],
      title: "Expect column values to be between",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToBeDateutilParseable: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        library_metadata: {
          default: {
            contributors: ["@great_expectations"],
            has_full_test_suite: true,
            manually_reviewed_code: true,
            maturity: "production",
            requirements: [],
            tags: ["core expectation", "column map expectation"],
          },
          title: "Library Metadata",
          type: "object",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnValuesToBeDateutilParseable",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_values_to_be_dateutil_parseable",
              title: "Expectation Type",
              type: "string",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "mostly"],
      title: "ExpectColumnValuesToBeDateutilParseable",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToBeDecreasing: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        library_metadata: {
          default: {
            contributors: ["@great_expectations"],
            has_full_test_suite: true,
            manually_reviewed_code: true,
            maturity: "production",
            requirements: [],
            tags: ["core expectation", "column map expectation"],
          },
          title: "Library Metadata",
          type: "object",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnValuesToBeDecreasing",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_values_to_be_decreasing",
              title: "Expectation Type",
              type: "string",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        strictly: { title: "Strictly", type: "boolean" },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "mostly"],
      title: "ExpectColumnValuesToBeDecreasing",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToBeInSet: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Validity"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectColumnValuesToBeInSet", title: "Expectation Class", type: "string" },
            expectation_type: { const: "expect_column_values_to_be_in_set", title: "Expectation Type", type: "string" },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect each column value to be in a given set.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        value_set: {
          description: "A set of objects used for comparison.",
          oneOf: [
            {
              title: "Text",
              type: "array",
              items: { type: "string", minLength: 1 },
              minItems: 1,
              examples: [
                ["a", "b", "c", "d", "e"],
                ["2024-01-01", "2024-01-02", "2024-01-03", "2024-01-04", "2024-01-05"],
              ],
            },
            {
              title: "Numbers",
              type: "array",
              items: { type: "number" },
              minItems: 1,
              examples: [
                [1, 2, 3, 4, 5],
                [1.1, 2.2, 3.3, 4.4, 5.5],
                [1, 2.2, 3, 4.4, 5],
              ],
            },
          ],
          title: "Value Set",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "value_set", "mostly"],
      title: "Expect column values to be in set",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToBeInTypeList: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Schema"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnValuesToBeInTypeList",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_values_to_be_in_type_list",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect a column to contain values from a specified type list.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: ["Spark", "SQLite", "PostgreSQL", "MSSQL", "BigQuery", "Redshift"],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        type_list: {
          description:
            "\n    A list of strings representing the data type that each column should have as entries.     Valid types are defined by the current backend implementation and are dynamically loaded.\n    ",
          items: { minLength: 1, type: "string" },
          minItems: 1,
          title: "Type List",
          type: "array",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "mostly"],
      title: "Expect column values to be in type list",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToBeIncreasing: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        library_metadata: {
          default: {
            contributors: ["@great_expectations"],
            has_full_test_suite: true,
            manually_reviewed_code: true,
            maturity: "production",
            requirements: [],
            tags: ["core expectation", "column map expectation"],
          },
          title: "Library Metadata",
          type: "object",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnValuesToBeIncreasing",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_values_to_be_increasing",
              title: "Expectation Type",
              type: "string",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        strictly: { title: "Strictly", type: "boolean" },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "mostly"],
      title: "ExpectColumnValuesToBeIncreasing",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToBeJsonParseable: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        library_metadata: {
          default: {
            contributors: ["@great_expectations"],
            has_full_test_suite: true,
            manually_reviewed_code: true,
            maturity: "production",
            requirements: [],
            tags: ["core expectation", "column map expectation"],
          },
          title: "Library Metadata",
          type: "object",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnValuesToBeJsonParseable",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_values_to_be_json_parseable",
              title: "Expectation Type",
              type: "string",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "mostly"],
      title: "ExpectColumnValuesToBeJsonParseable",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToBeNull: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Completeness"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectColumnValuesToBeNull", title: "Expectation Class", type: "string" },
            expectation_type: { const: "expect_column_values_to_be_null", title: "Expectation Type", type: "string" },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the column values to be null.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        to_be_between: {
          oneOf: [
            {
              title: "the fixed value",
              type: "object",
              properties: {
                mostly: {
                  description: "Successful if at least `mostly` fraction of values match the expectation.",
                  maximum: 1,
                  minimum: 0,
                  multipleOf: 0.01,
                  type: "number",
                },
                isFixedRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["mostly", "isFixedRange"],
            },
            {
              title: "the dynamic parameter",
              type: "object",
              properties: {
                offset: { type: "string", enum: ["-", "+"], default: "-" },
                percent: { default: 0, maximum: 1, minimum: 0, multipleOf: 0.01, type: "number" },
                range: { type: "number" },
                strict: { type: "boolean", default: false },
                isDynamicRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["offset", "percent", "range", "isDynamicRange"],
            },
          ],
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "mostly"],
      title: "Expect column values to be null",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToBeOfType: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Schema"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectColumnValuesToBeOfType", title: "Expectation Class", type: "string" },
            expectation_type: {
              const: "expect_column_values_to_be_of_type",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect a column to contain values of a specified data type.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        type_: {
          description:
            "\n    A string representing the data type that each column should have as entries.     Valid types are defined by the current backend implementation and are dynamically loaded.\n    ",
          title: "Type ",
          type: "string",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "type_", "mostly"],
      title: "Expect column values to be of type",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToBeUnique: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Uniqueness"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectColumnValuesToBeUnique", title: "Expectation Class", type: "string" },
            expectation_type: { const: "expect_column_values_to_be_unique", title: "Expectation Type", type: "string" },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect each column value to be unique.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "mostly"],
      title: "Expect column values to be unique",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToMatchJsonSchema: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        json_schema: { title: "Json Schema", type: "object" },
        library_metadata: {
          default: {
            contributors: ["@great_expectations"],
            has_full_test_suite: true,
            manually_reviewed_code: true,
            maturity: "production",
            requirements: [],
            tags: ["core expectation", "column map expectation"],
          },
          title: "Library Metadata",
          type: "object",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnValuesToMatchJsonSchema",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_values_to_match_json_schema",
              title: "Expectation Type",
              type: "string",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "json_schema", "mostly"],
      title: "ExpectColumnValuesToMatchJsonSchema",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToMatchLikePattern: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        like_pattern: {
          description: "The SQL like pattern expression the column entries should match.",
          title: "Like Pattern",
          type: "string",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Validity"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnValuesToMatchLikePattern",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_values_to_match_like_pattern",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the column entries to be strings that match a given like pattern expression.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "SQLite",
                "PostgreSQL",
                "Redshift",
                "MySQL",
                "MSSQL",
                "Databricks (SQL)",
                "BigQuery",
                "Snowflake",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "like_pattern", "mostly"],
      title: "Expect column values to match like pattern",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToMatchLikePatternList: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        like_pattern_list: {
          description: "The list of SQL like pattern expressions the column entries should match.",
          items: { type: "string" },
          title: "Like Pattern List",
          type: "array",
        },
        match_on: {
          default: "any",
          description:
            "'any' or 'all'. Use 'any' if the value should match at least one like pattern in the list. Use 'all' if it should match each like pattern in the list.",
          enum: ["any", "all"],
          title: "Match On",
          type: "string",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Validity"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnValuesToMatchLikePatternList",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_values_to_match_like_pattern_list",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const:
                "Expect the column entries to be strings that match any of a provided list of like pattern expressions.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "SQLite",
                "PostgreSQL",
                "Redshift",
                "MySQL",
                "MSSQL",
                "Databricks (SQL)",
                "BigQuery",
                "Snowflake",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "like_pattern_list", "mostly"],
      title: "Expect column values to match like pattern list",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToMatchRegex: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Validity"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectColumnValuesToMatchRegex", title: "Expectation Class", type: "string" },
            expectation_type: {
              const: "expect_column_values_to_match_regex",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the column entries to be strings that match a given regular expression.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: ["Pandas", "Spark", "SQLite", "PostgreSQL", "MySQL", "BigQuery", "Databricks (SQL)", "Redshift"],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        regex: {
          default: "(?s).*",
          description: "The regular expression the column entries should match.",
          title: "Regex",
          type: "string",
        },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "mostly"],
      title: "Expect column values to match regex",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToMatchRegexList: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        match_on: {
          default: "any",
          description:
            "'any' or 'all'. Use 'any' if the value should match at least one regular expression in the list. Use 'all' if it should match each regular expression in the list.",
          enum: ["any", "all"],
          title: "Match On",
          type: "string",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Validity"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnValuesToMatchRegexList",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_values_to_match_regex_list",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const:
                "Expect the column entries to be strings that can be matched to either any of or all of a list of regular expressions.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: ["Pandas", "Spark", "SQLite", "PostgreSQL", "MySQL", "BigQuery", "Databricks (SQL)", "Redshift"],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        regex_list: {
          description: "The list of regular expressions which the column entries should match.",
          items: { type: "string" },
          title: "Regex List",
          type: "array",
        },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "regex_list", "mostly"],
      title: "Expect column values to match regex list",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToMatchStrftimeFormat: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        library_metadata: {
          default: {
            contributors: ["@great_expectations"],
            has_full_test_suite: true,
            manually_reviewed_code: true,
            maturity: "production",
            requirements: [],
            tags: ["core expectation", "column map expectation"],
          },
          title: "Library Metadata",
          type: "object",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnValuesToMatchStrftimeFormat",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_values_to_match_strftime_format",
              title: "Expectation Type",
              type: "string",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        strftime_format: { anyOf: [{ type: "string" }, { type: "object" }], title: "Strftime Format" },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "strftime_format", "mostly"],
      title: "ExpectColumnValuesToMatchStrftimeFormat",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToNotBeInSet: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Validity"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectColumnValuesToNotBeInSet", title: "Expectation Class", type: "string" },
            expectation_type: {
              const: "expect_column_values_to_not_be_in_set",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect column entries to not be in the set.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        value_set: {
          description: "A set of objects used for comparison.",
          oneOf: [
            {
              title: "Text",
              type: "array",
              items: { type: "string", minLength: 1 },
              minItems: 1,
              examples: [
                ["a", "b", "c", "d", "e"],
                ["2024-01-01", "2024-01-02", "2024-01-03", "2024-01-04", "2024-01-05"],
              ],
            },
            {
              title: "Numbers",
              type: "array",
              items: { type: "number" },
              minItems: 1,
              examples: [
                [1, 2, 3, 4, 5],
                [1.1, 2.2, 3.3, 4.4, 5.5],
                [1, 2.2, 3, 4.4, 5],
              ],
            },
          ],
          title: "Value Set",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "value_set", "mostly"],
      title: "Expect column values to not be in set",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToNotBeNull: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Completeness"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectColumnValuesToNotBeNull", title: "Expectation Class", type: "string" },
            expectation_type: {
              const: "expect_column_values_to_not_be_null",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the column values to not be null.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        to_be_between: {
          oneOf: [
            {
              title: "the fixed value",
              type: "object",
              properties: {
                mostly: {
                  description: "Successful if at least `mostly` fraction of values match the expectation.",
                  maximum: 1,
                  minimum: 0,
                  multipleOf: 0.01,
                  type: "number",
                },
                isFixedRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["mostly", "isFixedRange"],
            },
            {
              title: "the dynamic parameter",
              type: "object",
              properties: {
                offset: { type: "string", enum: ["-", "+"], default: "-" },
                percent: { default: 0, maximum: 1, minimum: 0, multipleOf: 0.01, type: "number" },
                range: { type: "number" },
                strict: { type: "boolean", default: false },
                isDynamicRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["offset", "percent", "range", "isDynamicRange"],
            },
          ],
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "mostly"],
      title: "Expect column values to not be null",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToNotMatchLikePattern: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        like_pattern: {
          description: "The SQL like pattern expression the column entries should NOT match.",
          title: "Like Pattern",
          type: "string",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Validity"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnValuesToNotMatchLikePattern",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_values_to_not_match_like_pattern",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the column entries to be strings that do NOT match a given like pattern expression.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: ["SQLite", "PostgreSQL", "Redshift", "MySQL", "MSSQL", "Databricks (SQL)", "Snowflake"],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "like_pattern", "mostly"],
      title: "Expect column values to not match like pattern",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToNotMatchLikePatternList: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        like_pattern_list: {
          description: "The list of SQL like pattern expressions the column entries should NOT match.",
          items: { type: "string" },
          title: "Like Pattern List",
          type: "array",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Validity"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnValuesToNotMatchLikePatternList",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_values_to_not_match_like_pattern_list",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const:
                "Expect the column entries to be strings that do NOT match any of a provided list of like pattern expressions.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: ["SQLite", "PostgreSQL", "Redshift", "MySQL", "MSSQL", "Databricks (SQL)", "Snowflake"],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "like_pattern_list", "mostly"],
      title: "Expect column values to not match like pattern list",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToNotMatchRegex: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Validity"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnValuesToNotMatchRegex",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_values_to_not_match_regex",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the column entries to be strings that do NOT match a given regular expression.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: ["Pandas", "Spark", "SQLite", "PostgreSQL", "MySQL", "Databricks (SQL)", "Redshift"],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        regex: {
          description: "The regular expression the column entries should NOT match.",
          title: "Regex",
          type: "string",
        },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "regex", "mostly"],
      title: "Expect column values to not match regex",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectColumnValuesToNotMatchRegexList: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column: { description: "The column name.", minLength: 1, title: "Column", type: "string" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Validity"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "column", description: "Column Map", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectColumnValuesToNotMatchRegexList",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_column_values_to_not_match_regex_list",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "column map expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const:
                "Expect the column entries to be strings that do not match any of a list of regular expressions. Matches can be anywhere in the string.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: ["Pandas", "Spark", "PostgreSQL", "Redshift", "MySQL", "Databricks (SQL)", "SQLite"],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        regex_list: {
          description: "The list of regular expressions which the column entries should not match.",
          items: { type: "string" },
          title: "Regex List",
          type: "array",
        },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column", "regex_list", "mostly"],
      title: "Expect column values to not match regex list",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectCompoundColumnsToBeUnique: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column_list: {
          description: "Set of columns to be checked.",
          items: { minLength: 1, type: "string" },
          minItems: 1,
          title: "Column List",
          type: "array",
        },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        ignore_row_if: {
          default: "all_values_are_missing",
          enum: ["all_values_are_missing", "any_value_is_missing", "never"],
          title: "Ignore Row If",
          type: "string",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Uniqueness"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "multicolumn", description: "Multicolumn Map", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectCompoundColumnsToBeUnique", title: "Expectation Class", type: "string" },
            expectation_type: {
              const: "expect_compound_columns_to_be_unique",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "multi-column expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the compound columns to be unique.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column_list", "mostly"],
      title: "Expect compound columns to be unique",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectMulticolumnSumToEqual: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column_list: {
          description: "Set of columns to be checked.",
          items: { minLength: 1, type: "string" },
          minItems: 1,
          title: "Column List",
          type: "array",
        },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        ignore_row_if: {
          default: "all_values_are_missing",
          description: "If specified, sets the condition on which a given row is to be ignored.",
          enum: ["all_values_are_missing", "any_value_is_missing", "never"],
          title: "Ignore Row If",
          type: "string",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Numeric"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "multicolumn", description: "Multicolumn Map", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectMulticolumnSumToEqual", title: "Expectation Class", type: "string" },
            expectation_type: { const: "expect_multicolumn_sum_to_equal", title: "Expectation Type", type: "string" },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "multi-column expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const:
                "Expect that the sum of row values in a specified column list is the same for each row, and equal to a specified sum total.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        sum_total: { description: "Expected sum of columns", title: "Sum Total", type: "number" },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column_list", "sum_total", "mostly"],
      title: "Expect multicolumn sum to equal",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectQueryResultsToMatchComparison: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        base_query: {
          description: "A SQL query to be executed for this Data Asset.",
          title: "Base Query",
          type: "string",
        },
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        comparison_data_source_name: {
          description: "The name of the comparison Data Source to compare this Asset against.",
          title: "Comparison Data Source Name",
          type: "string",
        },
        comparison_query: {
          description: "A SQL query to be executed for the comparison Data Source.",
          title: "Comparison Query",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Multi-source"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "table", description: "Batch", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectQueryResultsToMatchComparison",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_query_results_to_match_comparison",
              title: "Expectation Type",
              type: "string",
            },
            short_description: {
              const:
                "This Expectation will check if the results of a query matches the results of a query against another Data Source.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: ["PostgreSQL", "Snowflake", "Databricks (SQL)", "Redshift", "SQLite"],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["base_query", "comparison_data_source_name", "comparison_query", "mostly"],
      title: "Expect query results to match comparison",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectSelectColumnValuesToBeUniqueWithinRecord: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: true, title: "Catch Exceptions", type: "boolean" },
        column_list: {
          description: "The column names to evaluate.",
          items: { minLength: 1, type: "string" },
          minItems: 1,
          title: "Column List",
          type: "array",
        },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        ignore_row_if: {
          default: "all_values_are_missing",
          description: "If specified, sets the condition on which a given row is to be ignored.",
          title: "Ignore Row If",
          type: "string",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Uniqueness"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "multicolumn", description: "Multicolumn Map", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectSelectColumnValuesToBeUniqueWithinRecord",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_select_column_values_to_be_unique_within_record",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "multi-column expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const:
                "Expect the values for each record to be unique across the columns listed. Note that records can be duplicated.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        mostly: {
          default: 1,
          description: "Successful if at least `mostly` fraction of values match the Expectation.",
          maximum: 1.0,
          minimum: 0.0,
          multipleOf: 0.01,
          title: "Mostly",
          type: "number",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["column_list", "mostly"],
      title: "Expect select column values to be unique within record",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectTableColumnCountToBeBetween: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        max_value: {
          anyOf: [{ type: "number" }, { type: "string", format: "date" }, { type: "string", format: "date-time" }],
          description: "The maximum number of columns, inclusive.",
          title: "Max Value",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Schema"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "table", description: "Batch", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectTableColumnCountToBeBetween",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_table_column_count_to_be_between",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "table expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the number of columns in a table to be between two values.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        min_value: {
          anyOf: [{ type: "number" }, { type: "string", format: "date" }, { type: "string", format: "date-time" }],
          description: "The minimum number of columns, inclusive.",
          title: "Min Value",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        to_be_between: {
          default: { max_value: null, min_value: null },
          oneOf: [
            {
              title: "a dynamic range of",
              type: "object",
              properties: {
                offset: { type: "string", enum: ["+/-", "+", "-"], default: "+/-" },
                percent: { type: "number" },
                range: { type: "number" },
                strict: { type: "boolean", default: false },
                isDynamicRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["offset", "percent", "range", "isDynamicRange"],
            },
            {
              title: "the fixed values",
              type: "object",
              properties: {
                max_value: {
                  title: "Max Value",
                  description: "The maximum number of columns, inclusive.",
                  anyOf: [
                    { type: "number" },
                    { type: "string", format: "date" },
                    { type: "string", format: "date-time" },
                    { type: "null" },
                  ],
                },
                min_value: {
                  title: "Min Value",
                  description: "The minimum number of columns, inclusive.",
                  anyOf: [
                    { type: "number" },
                    { type: "string", format: "date" },
                    { type: "string", format: "date-time" },
                    { type: "null" },
                  ],
                },
                isFixedRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["isFixedRange"],
            },
          ],
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      title: "Expect table column count to be between",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectTableColumnCountToEqual: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Schema"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "table", description: "Batch", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectTableColumnCountToEqual", title: "Expectation Class", type: "string" },
            expectation_type: {
              const: "expect_table_column_count_to_equal",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "table expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the number of columns in a table to equal a value.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        value: { description: "The expected number of columns.", title: "Value", type: "integer" },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["value"],
      title: "Expect table column count to equal",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectTableColumnsToMatchOrderedList: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        column_list: {
          description: "The column names, in the correct order.",
          items: { minLength: 1, type: "string" },
          minItems: 1,
          title: "Column List",
          type: "array",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Schema"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "table", description: "Batch", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectTableColumnsToMatchOrderedList",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_table_columns_to_match_ordered_list",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "table expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the columns in a table to exactly match a specified list.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      title: "Expect table columns to match ordered list",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectTableColumnsToMatchSet: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        column_set: {
          description:
            "The column names, in any order. In SQL datasources, if the column names are double quoted, for example '\"column_name\"', a case sensitive match is done. Otherwise a case insensitive match is done.",
          items: { type: "string" },
          title: "Column Set",
          type: "array",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        exact_match: {
          default: true,
          description:
            "If True, the list of columns must exactly match the observed columns. If False, observed columns must include column_set but additional columns will pass.",
          title: "Exact Match",
          type: "boolean",
        },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Schema"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "table", description: "Batch", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectTableColumnsToMatchSet", title: "Expectation Class", type: "string" },
            expectation_type: { const: "expect_table_columns_to_match_set", title: "Expectation Type", type: "string" },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "table expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the columns in a table to match an unordered set.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      title: "Expect table columns to match set",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectTableRowCountToBeBetween: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        max_value: {
          anyOf: [{ type: "integer" }, { type: "string", format: "date-time" }],
          description: "The maximum number of rows, inclusive.",
          title: "Max Value",
        },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Volume"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "table", description: "Batch", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectTableRowCountToBeBetween", title: "Expectation Class", type: "string" },
            expectation_type: {
              const: "expect_table_row_count_to_be_between",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "table expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the number of rows to be between two values.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        min_value: {
          anyOf: [{ type: "integer" }, { type: "string", format: "date-time" }],
          description: "The minimum number of rows, inclusive.",
          title: "Min Value",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        strict_max: {
          default: false,
          description: "If True, the row count must be strictly larger than min_value, default=False",
          title: "Strict Max",
          type: "boolean",
        },
        strict_min: {
          default: false,
          description: "If True, the row count must be strictly smaller than max_value, default=False",
          title: "Strict Min",
          type: "boolean",
        },
        to_be_between: {
          default: { max_value: null, min_value: null, strict_max: false, strict_min: false },
          oneOf: [
            {
              title: "a forecasted range",
              type: "object",
              properties: {
                isForecastRange: {
                  description: "Indicates that this option is selected",
                  type: "boolean",
                  default: true,
                },
              },
              required: ["isForecastRange"],
              additionalProperties: false,
            },
            {
              title: "a dynamic range of",
              type: "object",
              properties: {
                offset: { type: "string", enum: ["+/-", "+", "-"], default: "+/-" },
                percent: { type: "number" },
                range: { type: "number" },
                strict: { type: "boolean", default: false },
                isDynamicRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["offset", "percent", "range", "isDynamicRange"],
            },
            {
              title: "the fixed values",
              type: "object",
              properties: {
                max_value: {
                  title: "Max Value",
                  description: "The maximum number of rows, inclusive.",
                  anyOf: [{ type: "integer" }, { type: "string", format: "date-time" }, { type: "null" }],
                },
                strict_max: { type: "boolean", default: false },
                min_value: {
                  title: "Min Value",
                  description: "The minimum number of rows, inclusive.",
                  anyOf: [{ type: "integer" }, { type: "string", format: "date-time" }, { type: "null" }],
                },
                strict_min: { type: "boolean", default: false },
                isFixedRange: { description: "Indicates this option is selected", type: "boolean", default: true },
              },
              required: ["isFixedRange"],
            },
          ],
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      title: "Expect table row count to be between",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectTableRowCountToEqual: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Volume"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "table", description: "Batch", title: "Domain Type", type: "string" },
            expectation_class: { const: "ExpectTableRowCountToEqual", title: "Expectation Class", type: "string" },
            expectation_type: { const: "expect_table_row_count_to_equal", title: "Expectation Type", type: "string" },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "table expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the number of rows to equal a value.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: [
                "Pandas",
                "Spark",
                "SQLite",
                "PostgreSQL",
                "MySQL",
                "MSSQL",
                "BigQuery",
                "Snowflake",
                "Databricks (SQL)",
                "Redshift",
              ],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        value: { description: "The expected number of rows.", title: "Value", type: "integer" },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["value"],
      title: "Expect table row count to equal",
      type: "object",
    } as const satisfies JSONSchema,
  },
  expectTableRowCountToEqualOtherTable: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        condition_parser: {
          enum: ["great_expectations", "great_expectations__experimental__", "pandas", "spark"],
          title: "Condition Parser",
          type: "string",
        },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["Volume"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "table", description: "Batch", title: "Domain Type", type: "string" },
            expectation_class: {
              const: "ExpectTableRowCountToEqualOtherTable",
              title: "Expectation Class",
              type: "string",
            },
            expectation_type: {
              const: "expect_table_row_count_to_equal_other_table",
              title: "Expectation Type",
              type: "string",
            },
            library_metadata: {
              const: {
                contributors: ["@great_expectations"],
                has_full_test_suite: true,
                manually_reviewed_code: true,
                maturity: "production",
                requirements: [],
                tags: ["core expectation", "table expectation", "multi-table expectation"],
              },
              title: "Library Metadata",
              type: "object",
            },
            short_description: {
              const: "Expect the number of rows to equal the number in another table within the same database.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: ["SQLite", "PostgreSQL", "Redshift", "MySQL", "MSSQL", "Databricks (SQL)", "Snowflake"],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        other_table_name: {
          description: "The name of the other table. Other table must be located within the same database.",
          title: "Other Table Name",
          type: "string",
        },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        row_condition: {
          properties: {
            column: { title: "Column", type: "string" },
            operator: {
              enum: [
                "is",
                "is not",
                "is null",
                "is not null",
                "is on",
                "is not on",
                "is before",
                "is before or on",
                "is after",
                "is after or on",
                ">",
                "<",
                ">=",
                "<=",
                "=",
                "!=",
              ],
              title: "Operator",
              type: "string",
            },
            parameter: {
              anyOf: [
                { type: "number" },
                { type: "string", format: "date" },
                { type: "string", format: "date-time" },
                { type: "string" },
                { type: "null" },
              ],
              title: "Parameter",
            },
          },
          required: ["column", "operator"],
          type: "object",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["other_table_name"],
      title: "Expect table row count to equal other table",
      type: "object",
    } as const satisfies JSONSchema,
  },
  unexpectedRowsExpectation: {
    schema: {
      additionalProperties: false,
      definitions: {
        Offset: {
          additionalProperties: false,
          description: "A threshold in which a metric will be considered passable",
          properties: {
            negative: { title: "Negative", type: "number" },
            positive: { title: "Positive", type: "number" },
          },
          required: ["positive", "negative"],
          title: "Offset",
          type: "object",
        },
        ResultFormat: {
          description: "An enumeration.",
          enum: ["BOOLEAN_ONLY", "BASIC", "COMPLETE", "SUMMARY"],
          title: "ResultFormat",
          type: "string",
        },
        Window: {
          additionalProperties: false,
          description: "A definition for a temporal window across <`range`> number of previous invocations",
          properties: {
            constraint_fn: { title: "Constraint Fn", type: "string" },
            offset: { $ref: "#/definitions/Offset" },
            parameter_name: { title: "Parameter Name", type: "string" },
            range: { title: "Range", type: "integer" },
            strict: { default: false, title: "Strict", type: "boolean" },
          },
          required: ["constraint_fn", "parameter_name", "range", "offset"],
          title: "Window",
          type: "object",
        },
      },
      properties: {
        batch_id: { title: "Batch Id", type: "string" },
        catch_exceptions: { default: false, title: "Catch Exceptions", type: "boolean" },
        description: { description: "A short description of your Expectation", title: "Description", type: "string" },
        id: { title: "Id", type: "string" },
        meta: { title: "Meta", type: "object" },
        metadata: {
          properties: {
            data_quality_issues: { const: ["SQL"], title: "Data Quality Issues", type: "array" },
            domain_type: { const: "table", description: "Batch", title: "Domain Type", type: "string" },
            expectation_class: { const: "UnexpectedRowsExpectation", title: "Expectation Class", type: "string" },
            expectation_type: { const: "unexpected_rows_expectation", title: "Expectation Type", type: "string" },
            short_description: {
              const:
                "This Expectation will fail validation if the query returns one or more rows. The WHERE clause defines the fail criteria.",
              title: "Short Description",
              type: "string",
            },
            supported_data_sources: {
              const: ["Spark", "PostgreSQL", "Redshift", "MySQL", "BigQuery", "Snowflake", "Databricks (SQL)"],
              title: "Supported Data Sources",
              type: "array",
            },
          },
          type: "object",
        },
        notes: { anyOf: [{ type: "string" }, { type: "array", items: { type: "string" } }], title: "Notes" },
        rendered_content: { items: { type: "object" }, title: "Rendered Content", type: "array" },
        result_format: {
          anyOf: [{ $ref: "#/definitions/ResultFormat" }, { type: "object" }],
          default: "BASIC",
          title: "Result Format",
        },
        unexpected_rows_query: {
          description: "A SQL or Spark-SQL query to be executed for validation.",
          title: "Unexpected Rows Query",
          type: "string",
        },
        windows: {
          default: [],
          description: "Definition(s) for evaluation of temporal windows",
          items: { $ref: "#/definitions/Window" },
          title: "Windows",
          type: "array",
        },
      },
      required: ["unexpected_rows_query"],
      title: "Custom Expectation with SQL",
      type: "object",
    } as const satisfies JSONSchema,
  },
}
